<template>
    <div
            class="under-video-promotional-banners loadable failable"
            :class="{loading: loading, failed: error}"
            v-show="show"
    >
        <div class="content" v-if="promotionalBanners.length">
            <PromotionalBanner
                    v-for="promotionalBanner in promotionalBanners"
                    :key="promotionalBanner.id"
                    :promotional-banner="promotionalBanner"
            />
        </div>
        <div class="loader-wrapper">
            <Spinner/>
        </div>
        <div class="failed-wrapper">
            <div>
                <div class="block">
                    <p>
                        {{$t('error')}}
                    </p>
                    <button
                            type="button"
                            @click.prevent="loadPromotionalBanners"
                    >
                        {{$t('retry')}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Spinner from './Spinner';
    import resources from '../resources';
    import EventBus from '../eventbus';
    import PromotionalBanner from './PromotionalBanner';

    export default {
        components: {
            PromotionalBanner,
            Spinner,
        },
        props: {

        },
        data(){
            return {
                error: null,
                loading: false,
                promotionalBanners: [],
            }
        },
        methods: {
            loadPromotionalBanners(){
                this.error = false;
                this.loading = true;
                this.promotionalBanners = [];

                return resources.promotionalBanners.index({active: 1, limit: 1, type: 'under_videos'})
                    .then((resp) => {
                        this.promotionalBanners = resp.data.data;
                        this.loading = false;
                    }).catch((err) => {
                        this.error = err;
                        this.loading = false;
                    });
            }
        },
        computed:{
            show(){
                return this.promotionalBanners.length !== 0 || this.error || this.loading;
            }
        },
        mounted(){
            this.loadPromotionalBanners();

            EventBus.$on('languageChanged', () => {
                this.loadPromotionalBanners();
            });
        },
    }
</script>
<style scoped lang="scss">
    .under-video-promotional-banners{
        &.loading, &.failed{
            padding: 1em;
            text-align: center;
        }

        &.loading{
            min-height: 100px;
        }

        &.failed{
            min-height: 125px;
        }
    }
</style>